import MediaGroup, {
    type MediaGroupProps
} from "@/app/(site)/_components/GCSanityGroups/MediaGroup"
import { type ImageObjectFitSetting, type MediaGroupContentType } from "@/gc-sanity-types"

interface MediaBlockProps extends MediaGroupProps {
    media: MediaGroupContentType
    imageSizes?: string
    objectSetting?: ImageObjectFitSetting
}

export default function MediaBlock({
    className,
    isAboveTheFold,
    media,
    imageSizes,
    objectSetting
}: MediaBlockProps) {
    return (
        <MediaGroup
            imageSizes={imageSizes}
            className={className}
            isAboveTheFold={isAboveTheFold}
            media={media}
            objectSetting={objectSetting}
        />
    )
}
